import { useCallback, useState } from 'react'

export function useSearchValue() {
  const [searchValue, setSearchValue] = useState('')

  const updateSearchValue = useCallback((value: string) => {
    setSearchValue(value)
  }, [])

  return {
    searchValue,
    updateSearchValue,
  }
}
